export const RNGoogleSignin = {
  signIn: async () => {},
  signOut: async () => {},
};
